<template>
  <div class="card conteiner">
    <search id="searchComponent" class="mb-4" @getFilter="getFilter"></search>
    <div v-if="this.estado_id == 0" class="modal fade bd-example-modal-xl" id="viewSeller" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg bg-primary text-white">
            <h5 class="modal-title" id="exampleModalLabel">Datos vendedor</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body h5">
            <div class="row p-2">
                <div class="col-12 row "><label class="col-12 col-lg-3 text-lg-right font-weight-bold"><i class="fas fa-user"></i> Vendedor:</label><div class="col-12 col-lg-9">{{this.seller_name}}</div></div>
                <div class="col-12 row pt-2"><label class="col-12 col-lg-3 text-lg-right font-weight-bold"><i class="fas fa-phone pr-2"></i> Teléfono:</label><div class="col-12 col-lg-9">{{this.seller_phone}}</div></div>
                <div class="col-12 row pt-2"><label class="col-12 col-lg-3 text-lg-right font-weight-bold"><i class="fas fa-at pr-2"></i> Email:</label><div class="col-12 col-lg-9">{{this.seller_email}}</div></div>
                <div class="col-12 row pt-2"><label class="col-12 col-lg-3 text-lg-right font-weight-bold"><i class="fas fa-city pr-2"></i>Ciudad:</label><div class="col-12 col-lg-9">{{this.seller_city}}</div></div>    
            </div>         
          </div>          
        </div>
      </div>
    </div>

    <div v-if="this.estado_id == 0" class="modal fade bd-example-modal-xl" id="viewConfirm" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg bg-primary text-white">
            <h5 class="modal-title" id="exampleModalLabel">Evaluar la compra</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- svg from https://es.wikipedia.org/wiki/Archivo:Star*.svg -->
            <div class="col-12 alert alert-primary text-justify" role="alert">
                <i class="fas fa-exclamation-triangle pr-1"></i>
                <b>Nota:</b> Es importante para nosotros que evalúes al vendedor del producto, por lo que te invitamos a que nos hagas saber tu evaluación:
                <p class="pt-1">
                    <ul>
                        <li class="pb-1"><b>Positiva:</b> Cuando tu evaluación es positiva, indica que la compra se realizó efectivamente, por lo que puedes calificar al vendedor, de 1 a 5 estrellas, de acuerdo a tu experiencia con él.</li>
                        <li class="pb-1"><b>Negativa:</b> Cuando tu evaluación es negativa, debes seleccionar una de las razones por la cuál crees que debes evaluar negativamente al vendedor.</li>
                    </ul>
                </p>    
            </div>

            <div class="form-group row">
                <label for="OCOMB_evaluacion"
                    class="col-12 col-form-label">Evaluación<sup>&nbsp;(*)&nbsp;</sup></label>
                <div class="col-12">
                    <div class="row">
                        <div  class="input-group col-11">
                            <select name="evaluacion" id="OCOMB_evaluacion" v-model="selected_evaluacion"
                                class="form-control"
                                @change="setReason"
                                >
                                <option value="">Seleccione una evaluación</option>
                                <option value="1">Positiva</option>
                                <option value="2">Negativa</option>                                
                            </select>
                        </div>
                        
                        <span id="span_OCOMB_evaluacion" class="my-auto" aria-hidden="true"></span>
                    </div>
                    <div id="div_OCOMB_evaluacion" class="form-text text-danger"></div>
                </div>
            </div>

            <div :class="class_reason">
                <label for="OCOMB_reason"
                    class="col-12 col-form-label">Razón evaluación negativa<sup>&nbsp;(*)&nbsp;</sup></label>
                <div class="col-12">
                    <div class="row">
                        <div class="input-group col-11" >
                            <select name="reason" id="OCOMB_reason" v-model="selected_reason"
                                class="form-control">
                                <option value="">Seleccione una razón</option>
                                <option v-for="(reason, index) in reasons" v-bind:value="reason.id"
                                    :key="index">
                                    {{ reason.name }}
                                </option>
                                <option value="Otra">Otra razón</option>
                                <option value="POSITIVA" class="d-none">POSITIVA</option>
                            </select>
                        </div>
                        
                        <span id="span_OCOMB_reason" class="my-auto" aria-hidden="true"></span>
                    </div>
                    <div id="div_OCOMB_reason" class="form-text text-danger"></div>
                </div>
            </div>
            <div :class="class_estrellitas">

                <input id=rating0 type=radio value=0 name=rating checked  @change="getRating"/>

                <label class=star for=rating1>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-30 -30 636 572" height="2em">
                <path stroke="#605a00" stroke-width="5" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/>
                </svg>
                </label>
                <input id=rating1 type=radio value=1 name=rating @change="getRating" />

                <label class=star for=rating2>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-30 -30 636 572" height="2em">
                <path stroke="#605a00" stroke-width="5" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/>
                </svg>
                </label>
                <input id=rating2 type=radio value=2 name=rating @change="getRating" />

                <label class=star for=rating3>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-30 -30 636 572" height="2em">
                <path stroke="#605a00" stroke-width="5" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/>
                </svg>
                </label>
                <input id=rating3 type=radio value=3 name=rating @change="getRating" />

                <label class=star for=rating4>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-30 -30 636 572" height="2em">
                <path stroke="#605a00" stroke-width="5" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/>
                </svg>
                </label>
                <input id=rating4 type=radio value=4 name=rating @change="getRating" />

                <label class=star for=rating5>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-30 -30 636 572" height="2em">
                <path stroke="#605a00" stroke-width="5" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/>
                </svg>
                </label>
                <input id=rating5 type=radio value=5 name=rating @change="getRating" />

                <!-- por último el label del rating 0 ( sin calificar ) -->
                <label class=reset for=rating0>reset</label>

                <div id=texto>sin calificar</div>    
            </div>
            <div class="form-group row">
                <label for="ALNUM_obs_buyer" class="col-12 col-form-label">Comentario</label>
                <div class="col-md-12">
                    <div class="row">
                        <div class="input-group col-11">
                            <textarea ref="text_rating" rows="6" class="form-control cuenta_caracteres" id="ALNUM_obs_buyer" type="text" placeholder="Ingresa un comentario" onkeyup="validar(this.form);cuenta_caracteres(this)"
                            name="obs_buyer" autocomplete="details" maxlength="256" v-model="comment_buyer">                       
                            </textarea>    
                        </div>
                        <span id="span_ALNUM_obs_buyer" class="my-auto" aria-hidden="true"></span>
                    </div>
                    <div class="row justify-content-between">
                        <div class="col-11">
                        <div class="row no-gutters justify-content-between">
                            <div class="col-auto"><div id="div_ALNUM_obs_buyer" class="form-text text-danger"></div></div>
                            <div class="col-auto text-muted my-auto">Caracteres restantes: <i class="num_cuenta_carac">256</i></div></div>
                        </div>
                    </div>
       
                </div>
            </div>     
            <div class="col-12 pt-2">
                <button type="button" class="btn btn-primary"
                id="boton_evaluar"
                name="boton_evaluar"
                @click="saveConfirm()"
                data-dismiss="modal"
                >
                    <i class="fas fa-save"></i>
                    Calificar
                </button>
            </div>    
          </div>          
        </div>
      </div>
    </div>

    <div v-if="this.estado_id != 0" class="modal fade" id="viewConfirmSend" tabindex="-1" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
        <div class="modal-dialog  modal-lg modal-dialog-scrollable" role="document">
            <div class="modal-content">
            <div class="modal-header bg bg-primary text-white">
                <h5 class="modal-title" id="exampleModalScrollableTitle">Evaluar la venta</h5>
                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p class="mb-1 font-weight-bold px-0">Datos de venta</p>
                <hr class="bg-dark mt-0">
                <div class="form-group row">
                    <label for="ONUME_precio_venta" class="col-md-3 col-form-label text-md-right">Precio de venta<sup>&nbsp;(*)&nbsp;</sup></label>
                    <div class="col-md-9">
                    <div class="row">
                        <div class="input-group col-11">
                        <input ref="costoEnvio" id="ONUME_precio_venta" name="precio_venta" class="form-control  form-control-sm" v-model="salePrice" readonly
                        />
                        </div>
                        <span id="span_ONUME_precio_venta" class="my-auto" aria-hidden="true"></span>
                    </div>
                    <div id="div_ONUME_precio_venta" class="form-text text-danger"></div>
                    <div class="form-text text-danger"></div>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="ONUME_cantidad" class="col-md-3 col-form-label text-md-right">Cantidad<sup>&nbsp;(*)&nbsp;</sup></label>
                    <div class="col-md-9">
                    <div class="row">
                        <div class="input-group col-11">
                        <input ref="CantidadEnvio" id="ONUME_cantidad" name="cantidad_compra" class="form-control  form-control-sm" v-model="saleCantidad" readonly
                        />
                        </div>
                        <span id="span_ONUME_cantidad" class="my-auto" aria-hidden="true"></span>
                    </div>
                    <div id="div_ONUME_cantidad" class="form-text text-danger"></div>
                    <div class="form-text text-danger"></div>
                    </div>
                </div>
                <div class="form-group row d-none">
                    <label for="NUMER_costo_envio" class="col-md-3 col-form-label text-md-right">Costo de envío</label>
                    <div class="col-md-9">
                    <div class="row">
                        <div class="input-group col-11">
                        <input ref="costoEnvio" id="NUMER_costo_envio" name="costo_envio" @keyup="enmascararValor" class="form-control  form-control-sm"
                            data-toggle="tooltip" data-placement="top" v-model="sendPrice"
                            title="El costo de envío corresponde al dinero adicional que debe pagar el comprador, para recibir el producto. Este costo es opcional." />
                        </div>
                        <span id="span_NUMER_costo_envio" class="my-auto" aria-hidden="true"></span>
                    </div>
                    <div id="div_NUMER_costo_envio" class="form-text text-danger"></div>
                    <div class="form-text text-danger"></div>
                    </div>
                </div>

                <p class="mt-3 mb-1 font-weight-bold px-0">Evaluación del comprador</p>
                <hr class="bg-dark mt-0"> 
                <div class="col-12 alert alert-primary text-justify" role="alert">
                    <i class="fas fa-exclamation-triangle pr-1"></i>
                    <b>Nota:</b> Es importante para nosotros que evalúes al comprador del producto, por lo que te invitamos a que nos hagas saber tu evaluación:
                    <p class="pt-1">
                        <ul>
                            <li class="pb-1"><b>Positiva:</b> cuando tu evaluación es positiva, indica que la compra se realizó efectivamente, por lo que puedes calificar al comprador, de 1 a 5 estrellas, de acuerdo a tu experiencia con él.</li>
                            <li class="pb-1"><b>Negativa:</b> cuando tu evaluación es negativa, debes seleccionar una de las razones por la cuál crees que debes evaluar negativamente al comprador.</li>
                        </ul>
                    </p> 
                </div>

                <div class="form-group row">
                <label for="OCOMB_evaluacion"
                    class="col-12 col-form-label">Evaluación<sup>&nbsp;(*)&nbsp;</sup></label>
                <div class="col-12">
                    <div class="row">
                        <div class="input-group col-11">
                            <select name="evaluacion" id="OCOMB_evaluacion" v-model="selected_evaluacion"
                                class="form-control"
                                @change="setReason"
                                >
                                <option value="">Seleccione una evaluación</option>
                                <option value="1">Positiva</option>
                                <option value="2">Negativa</option>                                
                            </select>
                        </div>
                        <span id="span_OCOMB_evaluacion" class="my-auto" aria-hidden="true"></span>
                    </div>
                    <div id="div_OCOMB_evaluacion" class="form-text text-danger"></div>
                </div>
            </div>

            <div :class="class_reason">
                <label for="OCOMB_reason"
                    class="col-12 col-form-label">Razón evaluación negativa<sup>&nbsp;(*)&nbsp;</sup></label>
                <div class="col-12">
                    <div class="row">
                        <div class="input-group col-11">
                            <select name="reason" id="OCOMB_reason" v-model="selected_reason"
                                class="form-control">
                                <option value="">Seleccione una razón</option>
                                <option v-for="(reason, index) in reasons" v-bind:value="reason.id"
                                    :key="index">
                                    {{ reason.name }}
                                </option>
                                <option value="Otra">Otra razón</option>
                                <option value="POSITIVA" class="d-none">POSITIVA</option>
                            </select>
                        </div>
                        <span id="span_OCOMB_reason" class="my-auto" aria-hidden="true"></span>
                    </div>
                    <div id="div_OCOMB_reason" class="form-text text-danger"></div>
                </div>
            </div>
            <div :class="class_estrellitas">
                <input id=rating0 type=radio value=0 name=rating checked  @change="getRating"/>

                <label class=star for=rating1>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-30 -30 636 572" height="2em">
                <path stroke="#605a00" stroke-width="5" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/>
                </svg>
                </label>
                <input id=rating1 type=radio value=1 name=rating @change="getRating" />

                <label class=star for=rating2>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-30 -30 636 572" height="2em">
                <path stroke="#605a00" stroke-width="5" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/>
                </svg>
                </label>
                <input id=rating2 type=radio value=2 name=rating @change="getRating" />

                <label class=star for=rating3>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-30 -30 636 572" height="2em">
                <path stroke="#605a00" stroke-width="5" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/>
                </svg>
                </label>
                <input id=rating3 type=radio value=3 name=rating @change="getRating" />

                <label class=star for=rating4>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-30 -30 636 572" height="2em">
                <path stroke="#605a00" stroke-width="5" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/>
                </svg>
                </label>
                <input id=rating4 type=radio value=4 name=rating @change="getRating" />

                <label class=star for=rating5>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-30 -30 636 572" height="2em">
                <path stroke="#605a00" stroke-width="5" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/>
                </svg>
                </label>
                <input id=rating5 type=radio value=5 name=rating @change="getRating" />

                <!-- por último el label del rating 0 ( sin calificar ) -->
                <label class=reset for=rating0>reset</label>

                <div id=texto>sin calificar</div> 
            </div>       
            <div class="form-group row">
                <label for="ALNUM_obs_buyer" class="col-12 col-form-label">Comentario</label>
                <div class="col-md-12">
                    <div class="row">
                        <div class="input-group col-11">
                            <textarea ref="text_rating" rows="6" class="form-control cuenta_caracteres" id="ALNUM_obs_buyer" type="text" placeholder="Ingresa un comentario" onkeyup="validar(this.form);cuenta_caracteres(this)"
                            name="obs_buyer" autocomplete="details" maxlength="256" v-model="comment_buyer">                       
                            </textarea>    
                        </div>
                        <span id="span_ALNUM_obs_buyer" class="my-auto" aria-hidden="true"></span>
                    </div>
                    <div class="row justify-content-between">
                        <div class="col-11">
                        <div class="row no-gutters justify-content-between">
                            <div class="col-auto"><div id="div_ALNUM_obs_buyer" class="form-text text-danger"></div></div>
                            <div class="col-auto text-muted my-auto">Caracteres restantes: <i class="num_cuenta_carac">256</i></div></div>
                        </div>
                    </div>
       
                </div>
            </div>     
            
            <div class="col-12 pt-2">
                <button type="button" class="btn btn-primary"
                id="boton_evaluar"
                name="boton_evaluar"
                @click="saveConfirmBuy()"
                data-dismiss="modal"
                >
                    <i class="fas fa-save"></i>
                    Calificar
                </button>
            </div>
            </div>
            
            </div>
        </div>
    </div>
    <div v-if="this.estado_id != 0" class="modal fade" id="viewBuyerInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
        <div class="modal-dialog  modal-lg modal-dialog-scrollable" role="document">
            <div class="modal-content">
            <div class="modal-header bg bg-primary text-white">
                <h5 class="modal-title" id="exampleModalScrollableTitle">Detalle del comprador</h5>
                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p class="mb-1 font-weight-bold px-0">Datos del comprador</p>
                <hr class="bg-dark mt-0">
                <div class="row p-2">
                    <div class="col-12 row "><label class="col-12 col-lg-3 text-lg-right font-weight-bold"><i class="fas fa-user"></i> Comprador:</label><div class="col-12 col-lg-9">{{this.comprador.name/*+' '+this.comprador.first_lastname+' '+this.comprador.second_lastname*/}}</div></div>
                    <div class="col-12 row pt-2"><label class="col-12 col-lg-3 text-lg-right font-weight-bold"><i class="fas fa-phone pr-2"></i> Teléfono:</label><div class="col-12 col-lg-9">{{this.comprador.phone}}</div></div>
                    <div class="col-12 row pt-2"><label class="col-12 col-lg-3 text-lg-right font-weight-bold"><i class="fas fa-at pr-2"></i> Email:</label><div class="col-12 col-lg-9">{{this.comprador.email}}</div></div>
                    <div class="col-12 row pt-2"><label class="col-12 col-lg-3 text-lg-right font-weight-bold"><i class="fas fa-map-marker pr-2"></i>Dirección de entrega:</label><div class="col-12 col-lg-9">{{this.comprador.street_address+' '+comprador.number_address}}</div></div>    
                    <div class="col-12 row pt-2"><label class="col-12 col-lg-3 text-lg-right font-weight-bold"><i class="fas fa-info-circle pr-2"></i>Detalle dirección:</label><div class="col-12 col-lg-9">{{this.comprador.detail_address}}</div></div>    
                    <div class="col-12 row pt-2"><label class="col-12 col-lg-3 text-lg-right font-weight-bold"><i class="fas fa-city pr-2"></i>Ciudad:</label><div class="col-12 col-lg-9">{{this.comprador.city}}</div></div>    
                    <div class="col-12 row pt-2"><label class="col-12 col-lg-3 text-lg-right font-weight-bold"><i class="fas fa-map-pin pr-2"></i>Comuna:</label><div class="col-12 col-lg-9">{{this.comprador.comuna}}</div></div>    
                </div>
            </div>
            </div>
        </div>
    </div>

    <div class="modal fade bd-example-modal-xl" id="viewCalification" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg bg-primary text-white">
            <h5 class="modal-title" id="exampleModalLabel">Detalle de calificiones</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            
            <div class="review-block rounded" v-if="this.ratings[2]">
                <h6>{{ this.ratings[2].encabezado }}</h6>
                    <div class="row">
                        <div class="col-sm-3 col-lg-2">
                          <div class="review-block-name"><i :class="ratings[2].class_icono"></i></div>
                          <div class="review-block-name">{{ ratings[2].user_name }}</div>
                        </div>
                        <div class="col-sm-6 col-lg-7">                

                            <label v-for="n in range(this.ratings[2].qualification)" :key="n+'g2'" class=star for=rating1>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-30 -30 636 572" height="1.5em">
                            <path style="fill: #fe0" stroke="#605a00" stroke-width="5" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/>
                            </svg>
                            </label> 
                            
                            <label v-for="n in range(5- this.ratings[2].qualification)" :key="n+'b2'" class=star for=rating1>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-30 -30 636 572" height="1.5em">
                            <path style="fill: #fff" stroke="#605a00" stroke-width="5" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/>
                            </svg>
                            </label>     
                            
                        </div> 
                        <div class="col-sm-3">
                          <div class="review-block-date text-right">{{ this.ratings[2].fecha }}<br /></div>
                        </div>
                    </div> 
                    <div class="col-sm-9 col-lg-10 offset-sm-3 offset-lg-2">
                        {{ this.ratings[2].obs_rating ? this.ratings[2].obs_rating : 'Sin calificar' }}
                    </div> 
                </div>
                <div class="col-12" v-else>
                    <!--h6>{{ this.ratings[2].encabezado }}</h6-->
                    Sin calificar
                </div>

            
                <div class="review-block rounded" v-if="this.ratings[1]">
                    <h6>{{ this.ratings[1].encabezado   }}</h6>
                    <div class="row">
                        <div class="col-sm-3 col-lg-2">
                          <div class="review-block-name"><i :class="ratings[1].class_icono"></i></div>
                          <div class="review-block-name">{{ ratings[1].user_name }}</div>
                        </div>
                        <div class="col-sm-6 col-lg-7">                

                            <label v-for="n in range(this.ratings[1].qualification)" :key="n+'g1'" class=star for=rating1>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-30 -30 636 572" height="1.5em">
                            <path style="fill: #fe0" stroke="#605a00" stroke-width="5" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/>
                            </svg>
                            </label> 
                            
                            <label v-for="n in range(5- this.ratings[1].qualification)" :key="n+'b1'" class=star for=rating1>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-30 -30 636 572" height="1.5em">
                            <path style="fill: #fff" stroke="#605a00" stroke-width="5" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/>
                            </svg>
                            </label>     
                            
                        </div> 
                        <div class="col-sm-3">
                          <div class="review-block-date text-right">{{ this.ratings[1].fecha }}<br /></div>
                        </div>
                    </div> 
                    <div class="col-sm-9 col-lg-10 offset-sm-3 offset-lg-2">
                        {{ this.ratings[1].obs_rating ? this.ratings[1].obs_rating : 'Sin calificar' }}
                    </div> 
                </div>
                <div class="col-12" v-else>
                    <!--h6>{{ this.ratings[1].encabezado   }}</h6-->
                    Sin calificar
                </div>  
          </div>          
        </div>
      </div>
    </div>

    <nav>
        <ul class="nav nav-tabs" id="nav-tab" role="tablist">
            <li class="nav-item">
                <a v-if="compras[1]" class="nav-item nav-link active" id="nav-proceso-tab" data-toggle="tab" href="#nav-proceso" role="tab" aria-controls="nav-proceso" aria-selected="false"><i class="fas fa-shopping-bag"></i> En proceso</a>
            </li>
            <li class="nav-item">
                <a v-if="compras[2]" class="nav-link" id="nav-enviada-tab" data-toggle="tab" href="#nav-enviada" role="tab" aria-controls="nav-enviada" aria-selected="false"><i class="fas fa-paper-plane"></i> Enviada/Entregada</a>
            </li>            
            <li class="nav-item">
                <a v-if="compras[3]" class="nav-link" id="nav-recibida-tab" data-toggle="tab" href="#nav-recibida" role="tab" aria-controls="nav-recibida" aria-selected="false"><i class="fas fa-inbox"></i> Recibida</a>
            </li>         
            <li class="nav-item">
                <a v-if="compras[4]" class="nav-link" id="nav-norecibida-tab" data-toggle="tab" href="#nav-norecibida" role="tab" aria-controls="nav-norecibida" aria-selected="false"><i class="fas fa-inbox"></i> No Recibida</a>
            </li>         
        </ul>
    </nav>
    <div class="tab-content" id="nav-tabContent">
        
        <div class="tab-pane  fade show active" id="nav-proceso" role="tabpanel" aria-labelledby="nav-proceso-tab">
            <div class="card-body">
                <div class="row p-2">
                    <div v-if="this.estado_id == 0" class="col-6 h4 mb-1 font-weight-bold">Compras en proceso</div>
                    <div v-else class="col-6 h4 mb-1 font-weight-bold">Ventas en proceso</div>
                    <div v-if="this.estado_id != 0" class="col-6 mt-3 text-nowrap text-right">
                        <button type="button"  @click="$router.back()" class="btn btn-primary mb-1 text-right">
                            <i class="fas fa-arrow-left pr-1"></i>
                            Volver
                        </button> 
                    </div>
                </div>
    
                <div class="table-responsive">  
                    <div v-if="this.url != 'post.index'" class="alert alert-primary"><i class="fas fa-exclamation-triangle pr-2"></i><b>Nota:</b> Podrás calificar al vendedor pasado <b>3 días desde la fecha de compra</b>, o cuando el vendedor realice la <b>entrega/envío</b></div>
                    <table ref="tabla_contenedora_ep" class="table table-striped table-hover table-bordered">
                        <caption>Listado de compras en proceso</caption>
                        <thead>
                            <tr>
                                <th scope="col">Título</th>
                                <!--th scope="col">Categoría</th-->
                                <th scope="col">Fecha compra</th>
                                <th scope="col">Precio compra</th>
                                <th scope="col">Cantidad</th>
                                <th scope="col">Costo envío</th>
                                <th v-if="this.url == 'post.index'" scope="col">Datos comprador</th>
                                <th v-if="this.url != 'post.index'" scope="col">Datos vendedor</th>
                                <th scope="col">Acción</th>
                            </tr>
                        </thead>
                        <tbody v-if="this.estado_id == 0">
                            <tr v-for="(compra, index) in compras[1]" v-bind:value="compra.id" :key="index">
                                <td>{{compra.title}}</td>
                                <td class="text-nowrap">{{compra.sale_date}}</td>
                                <td class="text-nowrap">{{compra.price.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                })}}
                                </td>
                                <td class="text-nowrap">{{compra.cantidad_puja}}</td>
                                <td>Sin definir</td>
                                <td class="text-center text-nowrap">
                                    <a
                                        data-toggle="modal" data-target="#viewSeller"
                                        :data-id="compra.id_seller"
                                        @click="viewSeller(compra.user_name,compra.phone,compra.email,compra.city)"
                                        href="#"
                                    >
                                    {{compra.user_name}}
                                    </a>      
                                </td>
                                <td class="text-center text-nowrap">
                                    <a v-if="sumarDias(compra.sale_date,3)"
                                        data-toggle="modal" data-target="#viewConfirm"
                                        :data-id="compra.id_seller"
                                        @click="viewConfirm(compra.id_seller, compra.id, compra.fecha_envio)"
                                        class="btn btn-outline-success btn-block"
                                    >
                                    <i class="fas fa-comment-dots pr-1"></i>
                                    Calificar
                                    </a>
                                    <button  v-else type="button" disabled class="btn btn-outline-success btn-block">
                                        <i class="fas fa-ban pr-1"></i>
                                        Calificar
                                    </button>                 
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(compra, index) in compras[1]" v-bind:value="compra.id" :key="index">
                                <td>{{compra.title}}</td>
                                <td class="text-nowrap">{{compra.sale_date}}</td>
                                <td class="text-nowrap">{{compra.price.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    })}}
                                </td>
                                <td class="text-nowrap">{{compra.cantidad_puja}}</td>
                                <td>Sin definir</td>
                                <td><a
                                        data-toggle="modal" data-target="#viewBuyerInfo"
                                        :data-id="compra.id_buyer"
                                        @click="viewBuyerInfo(compra)"
                                        href="#"
                                    >{{compra.user_name}}
                                    </a>
                                </td>
                                <td class="text-center text-nowrap">
                                    <a
                                        data-toggle="modal" data-target="#viewConfirmSend"
                                        :data-id="compra.id_buyer"
                                        @click="viewConfirmSend(compra)"
                                        class="btn btn-outline-success btn-block"
                                    >
                                    <i class="fas fa-comment-dots pr-1"></i>
                                    Calificar
                                    </a>      
                                </td>
                                
                            </tr>
                        </tbody>
                    </table>        
                </div>
            </div>
        </div>
        <div class="tab-pane fade" id="nav-enviada" role="tabpanel" aria-labelledby="nav-enviada-tab">
            <div class="card-body">
                <div class="row p-2">
                    <div class="col-6 h4 mb-1 font-weight-bold">Compras enviadas/entregadas</div>
                    <div v-if="this.estado_id != 0" class="col-6 mt-3 text-nowrap text-right">
                        <button type="button"  @click="$router.back()" class="btn btn-primary mb-1 text-right">
                            <i class="fas fa-arrow-left pr-1"></i>
                            Volver
                        </button> 
                    </div>
                </div>
    
                <div class="table-responsive">  
                    <table ref="tabla_contenedora_en" class="table table-striped table-hover table-bordered">
                        <caption>Listado de compras enviadas</caption>
                        <thead>
                            <tr>
                                <th scope="col">Título</th>
                                <!--th scope="col">Categoría</th-->
                                <th scope="col">Fecha compra</th>
                                <th scope="col">Fecha envío</th>
                                <th scope="col">Precio compra</th>
                                <th scope="col">Cantidad</th>
                                <th scope="col">Costo envío</th>
                                <th scope="col">Precio final</th>
                                <th v-if="this.url != 'post.index'" scope="col">Acción</th>
                                <th v-else scope="col">Datos comprador</th>
                                <th scope="col">Calificaciones</th>
                            </tr>
                        </thead>
                        <tbody v-if="this.url != 'post.index'">
                            <tr v-for="(compra, index) in compras[2]" v-bind:value="compra.id" :key="index">
                                <td>{{compra.title}}</td>
                                <td style="white-space: pre;">{{ compra.sale_date.replace(" ", "\n") }}</td>
                                <td style="white-space: pre;">{{ compra.fecha_envio.replace(" ", "\n") }}</td>
                                <td class="text-nowrap">{{ compra.price.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    }) }}
                                </td>
                                <td class="text-nowrap">{{ compra.cantidad_puja }}</td>
                                <td class="text-nowrap">
                                    {{ compra.price_delivery.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    }) }}
                                </td>
                                <td class="text-nowrap">
                                    {{ (parseInt(compra.price_delivery)+(parseInt(compra.price) * parseInt(compra.cantidad_puja))).toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    }) }}
                                </td>
                                 <!-- td>{{compra.direccion}}</td -->
                                <td class="text-center text-nowrap">
                                    <a
                                        data-toggle="modal" data-target="#viewConfirm"
                                        :data-id="compra.id_seller"
                                        @click="viewConfirm(compra.id_seller, compra.id, compra.fecha_envio)"
                                        class="btn btn-outline-success btn-block"
                                    >
                                    <i class="fas fa-comment-dots pr-1"></i>
                                    Calificar
                                    </a>                   
                                </td>
                                <td class="text-center">
                                    <a
                                        data-toggle="modal" data-target="#viewCalification"
                                        :data-id="compra.id_seller"
                                        @click="viewCalification(compra.id)"
                                        class="btn btn-outline-primary btn-block"
                                    >
                                    <i class="far fa-eye pr-1"></i>
                                    Ver
                                    </a>                                                  
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(compra, index) in compras[2]" v-bind:value="compra.id" :key="index">
                                <td>{{compra.title}}</td>
                                <td style="white-space: pre;">{{ compra.sale_date.replace(" ", "\n") }}</td>
                                <td style="white-space: pre;">{{ compra.fecha_envio.replace(" ", "\n") }}</td>
                                <td class="text-nowrap">{{compra.price.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    }) }}
                                </td>
                                <td class="text-nowrap">{{ compra.cantidad_puja }}</td>
                                <td class="text-nowrap">
                                    {{compra.price_delivery.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    })}}
                                </td>
                                <td class="text-nowrap">
                                    {{(parseInt(compra.price_delivery)+(parseInt(compra.price) * parseInt(compra.cantidad_puja))).toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    })}}
                                </td>
                                 <td>
                                    <a
                                        data-toggle="modal" data-target="#viewBuyerInfo"
                                        :data-id="compra.id_buyer"
                                        @click="viewBuyerInfo(compra)"
                                        href="#"
                                    >
                                    {{compra.user_name}}
                                    </a>
                                  </td>
                                  <td class="text-center">
                                    <a
                                        data-toggle="modal" data-target="#viewCalification"
                                        :data-id="compra.id"
                                        @click="viewCalification(compra.id)"
                                        class="btn btn-outline-primary btn-block"
                                    >
                                    <i class="far fa-eye pr-1"></i>
                                    Ver
                                    </a>                                                  
                                </td>
                            </tr>
                        </tbody>
                    </table>        
                </div>
            </div>
        </div>
        <div class="tab-pane fade" id="nav-recibida" role="tabpanel" aria-labelledby="nav-recibida-tab">
            <div class="card-body">
                <div class="row p-2">
                    <div class="col-6 h4 mb-1 font-weight-bold">Compras recibidas</div>
                    <div v-if="this.estado_id != 0" class="col-6 mt-3 text-nowrap text-right">
                        <button type="button"  @click="$router.back()" class="btn btn-primary mb-1 text-right">
                            <i class="fas fa-arrow-left pr-1"></i>
                            Volver
                        </button> 
                    </div>
                </div>
    
                <div class="table-responsive">  
                    <table ref="tabla_contenedora_re" class="table table-striped table-hover table-bordered">
                        <caption>Listado de compras recibidas</caption>
                        <thead>
                            <tr>
                                <th scope="col">Título</th>
                                <!--th scope="col">Categoría</th-->
                                <th scope="col">Fecha compra</th>
                                <th scope="col">Fecha envío</th>
                                <th scope="col">Fecha recibo</th>
                                <th scope="col">Precio compra</th>
                                <th scope="col">Cantidad</th>
                                <th scope="col">Costo envío</th>
                                <th scope="col">Precio final</th>
                                <th v-if="this.url != 'post.index'" scope="col">Datos vendedor</th>
                                <th v-else scope="col">Datos comprador</th>
                                <th scope="col">Calificaciones</th>
                            </tr>
                        </thead>
                        <tbody  v-if="this.url != 'post.index'">
                            <tr v-for="(compra, index) in compras[3]" v-bind:value="compra.id" :key="index">
                                <td>{{compra.title}}</td>
                                <td style="white-space: pre;">{{ compra.sale_date.replace(" ", "\n") }}</td>
                                <td style="white-space: pre;">{{ compra.fecha_envio.replace(" ", "\n") }}</td>
                                <td style="white-space: pre;">{{ compra.fecha_recibo.replace(" ", "\n") }}</td>
                                <td class="text-nowrap">{{ compra.price.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    }) }}
                                </td>
                                <td class="text-nowrap">{{ compra.cantidad_puja }}</td>
                                <td class="text-nowrap">
                                    {{ compra.price_delivery.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    }) }}
                                </td>
                                <td class="text-nowrap">
                                    {{ (parseInt(compra.price_delivery) + (parseInt(compra.price) * parseInt(compra.cantidad_puja))).toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    }) }}
                                </td>
                                <td class="text-center text-nowrap">
                                    <a
                                        data-toggle="modal" data-target="#viewSeller"
                                        :data-id="compra.id_seller"
                                        @click="viewSeller(compra.user_name,compra.phone,compra.email,compra.city)"
                                        href="#"
                                    >
                                    {{compra.user_name}}
                                    </a>      
                                </td>
                                <td class="text-center">
                                    <a
                                        data-toggle="modal" data-target="#viewCalification"
                                        :data-id="compra.id_seller"
                                        @click="viewCalification(compra.id)"
                                        class="btn btn-outline-primary btn-block"
                                    >
                                    <i class="far fa-eye pr-1"></i>
                                    Ver
                                    </a>                                                  
                                </td>
                            </tr>
                        </tbody>
                        <tbody  v-else>
                            <tr v-for="(compra, index) in compras[3]" v-bind:value="compra.id" :key="index">
                                <td>{{compra.title}}</td>
                                <td style="white-space: pre;">{{ compra.sale_date.replace(" ", "\n") }}</td>
                                <td style="white-space: pre;">{{ compra.fecha_envio.replace(" ", "\n") }}</td>
                                <td style="white-space: pre;">{{ compra.fecha_recibo.replace(" ", "\n") }}</td>
                                <td class="text-nowrap">{{ compra.price.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    }) }}
                                </td>
                                <td class="text-nowrap">{{ compra.cantidad_puja }}</td>
                                <td class="text-nowrap">
                                    {{ compra.price_delivery.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    }) }}
                                </td>
                                <td class="text-nowrap">
                                    {{( parseInt(compra.price_delivery)+(parseInt(compra.price) * parseInt(compra.cantidad_puja))).toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    }) }}
                                </td>
                                <td>
                                    <a
                                        data-toggle="modal" data-target="#viewBuyerInfo"
                                        :data-id="compra.id_buyer"
                                        @click="viewBuyerInfo(compra)"
                                        href="#"
                                    >
                                    {{compra.user_name}}
                                    </a>
                                </td>
                                <td class="text-center">
                                    <a v-if="compra.fecha_envio != 'Fecha no disponible'"
                                        data-toggle="modal" data-target="#viewCalification"
                                        :data-id="compra.id_seller"
                                        @click="viewCalification(compra.id)"
                                        class="btn btn-outline-primary btn-block"
                                    >
                                    <i class="far fa-eye pr-1"></i>
                                    Ver
                                    </a> 
                                    <a v-else
                                        data-toggle="modal" data-target="#viewConfirmSend"
                                        :data-id="compra.id_buyer"
                                        @click="viewConfirmSend(compra)"
                                        class="btn btn-outline-success btn-block"
                                    >
                                    <i class="fas fa-comment-dots pr-1"></i>
                                    Calificar
                                    </a>                                                         
                                </td>
                            </tr>
                        </tbody>
                    </table>        
                </div>
            </div>
        </div>
        <div class="tab-pane fade" id="nav-norecibida" role="tabpanel" aria-labelledby="nav-norecibida-tab">
            <div class="card-body">
                <div class="row p-2">
                    <div class="col-6 h4 mb-1 font-weight-bold">Compras no recibidas</div>
                    <div v-if="this.estado_id != 0" class="col-6 mt-3 text-nowrap text-right">
                        <button type="button"  @click="$router.back()" class="btn btn-primary mb-1 text-right">
                            <i class="fas fa-arrow-left pr-1"></i>
                            Volver
                        </button> 
                    </div>
                </div>
    
                <div class="table-responsive">  
                    <table ref="tabla_contenedora_nr" class="table table-striped table-hover table-bordered">
                        <caption>Listado de compras no recibidas</caption>
                        <thead>
                            <tr>
                                <th scope="col">Título</th>
                                <!--th scope="col">Categoría</th-->
                                <th scope="col">Fecha compra</th>
                                <th scope="col">Fecha envío</th>
                                <th scope="col">Fecha recibo</th>
                                <th scope="col">Precio compra</th>
                                <th scope="col">Cantidad</th>
                                <th scope="col">Costo envío</th>
                                <th scope="col">Precio final</th>
                                <th v-if="this.url != 'post.index'" scope="col">Datos vendedor</th>
                                <th v-else scope="col">Datos comprador</th>
                                <th v-if="this.url == 'post.index'" scope="col">Acción</th>
                                <th scope="col">Calificaciones</th>
                            </tr>
                        </thead>
                        <tbody  v-if="this.url != 'post.index'">
                            <tr v-for="(compra, index) in compras[4]" v-bind:value="compra.id" :key="index">
                                <td>{{compra.title}}</td>
                                <td class="text-nowrap">{{compra.sale_date}}</td>
                                <td class="text-nowrap">{{compra.fecha_envio}}</td>
                                <td class="text-nowrap">{{compra.fecha_recibo}}</td>
                                <td class="text-nowrap">{{compra.price.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    })}}
                                </td>
                                <td class="text-nowrap">{{compra.cantidad_puja}}</td>
                                <td class="text-nowrap">
                                    {{compra.price_delivery.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    })}}
                                </td>
                                <td class="text-nowrap">
                                    {{(parseInt(compra.price_delivery) + (parseInt(compra.price) * parseInt(compra.cantidad_puja))).toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    })}}
                                </td>
                                <td class="text-center text-nowrap">
                                    <a
                                        data-toggle="modal" data-target="#viewSeller"
                                        :data-id="compra.id_seller"
                                        @click="viewSeller(compra.user_name,compra.phone,compra.email,compra.city)"
                                        href="#"
                                    >
                                    {{compra.user_name}}
                                    </a>  
                                </td>      
                                <td class="text-center">
                                    <a
                                        data-toggle="modal" data-target="#viewCalification"
                                        :data-id="compra.id_seller"
                                        @click="viewCalification(compra.id)"
                                        class="btn btn-outline-primary btn-block"
                                    >
                                    <i class="far fa-eye pr-1"></i>
                                    Ver
                                    </a>                                                  
                                </td>  
                            </tr>
                        </tbody>
                        <tbody  v-else>
                            <tr v-for="(compra, index) in compras[4]" v-bind:value="compra.id" :key="index">
                                <td>{{compra.title}}</td>
                                <td class="text-nowrap">{{compra.sale_date}}</td>
                                <td class="text-nowrap">{{compra.fecha_envio}}</td>
                                <td class="text-nowrap">{{compra.fecha_recibo}}</td>
                                <td class="text-nowrap">{{compra.price.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    })}}
                                </td>
                                <td class="text-nowrap">{{compra.cantidad_puja}}</td>
                                <td class="text-nowrap">
                                    {{compra.price_delivery.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    })}}
                                </td>
                                <td class="text-nowrap">
                                    {{(parseInt(compra.price_delivery)+(parseInt(compra.price) * parseInt(compra.cantidad_puja))).toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    })}}
                                </td>
                                <td>
                                    <a
                                        data-toggle="modal" data-target="#viewBuyerInfo"
                                        :data-id="compra.id_buyer"
                                        @click="viewBuyerInfo(compra)"
                                        href="#"
                                    >
                                    {{compra.user_name}}
                                    </a>
                                </td>
                                <td class="text-center text-nowrap">
                                    <a
                                        data-toggle="modal" data-target="#viewConfirmSend"
                                        :data-id="compra.id_buyer"
                                        @click="viewConfirmSend(compra)"
                                        class="btn btn-outline-success btn-block"
                                    >
                                    <i class="fas fa-comment-dots pr-1"></i>
                                    Calificar
                                    </a>      
                                </td>
                                <td class="text-center">
                                    <a
                                        data-toggle="modal" data-target="#viewCalification"
                                        :data-id="compra.id_seller"
                                        @click="viewCalification(compra.id)"
                                        class="btn btn-outline-primary btn-block"
                                    >
                                    <i class="far fa-eye pr-1"></i>
                                    Ver
                                    </a>                                                  
                                </td>
                            </tr>
                        </tbody>
                    </table>        
                </div>
            </div>
        </div>
    </div>


  </div>
</template>
<script>
import 'datatables.net-bs4';
import SearchComponentVue from "./SearchComponent.vue";
export default {
    components:{
        SearchComponentVue
    },
    props:['url','post_id','estado_id'],
    data: function () {
        return {
            postSelected: "",
            compras: [],
            total: 0,
            currentPage: 1,
            seller_name:'',
            seller_phone:'',
            seller_email:'',
            seller_city:'',
            seller_id:'',
            sale_id:'',
            salePrice:'',
            saleCantidad:'',
            sendPrice: '$0',
            rating:'',
            comment_buyer:'',
            view_recive:'',
            view_send:'',
            comprador: [],
            tipo_evaluacion: 0,
            selected_evaluacion: '',
            selected_reason: '',
            reasons: [],
            class_estrellitas:'d-none',
            class_reason: 'form-group row d-none',
            fecha_envio: '',
            dataLoaded: false,
            ratings: [],
            type_view: ''
        };
    },

    mounted() {
        this.loadPost();        
    },
    updated(){
        
        if (this.dataLoaded) {
            this.initializeDataTables();
        }
        //cuando viene de la vista de vendedor (Mis Ventas) entra con estado > 0
        if (this.estado_id > 0){
            $('#nav-tab li:nth-child('+this.estado_id+') a').tab('show') // Select first tab$('#myTab li:nth-child(3) a').tab('show')
        }
        //cuando viene de la vista del comprador (Mis compras) se inicializa dependiendo del arreglo de compras
        else {
            //console.log(this.compras);
            if (typeof this.compras[1] === 'object'  && this.view_recive != 1){
                
                $('#nav-tab li:nth-child(1) a').tab('show'); 
            }
            else if (!this.compras[1] && typeof this.compras[2] === 'object' && this.view_recive != 1){
                $('#nav-tab li:nth-child(2) a').tab('show');
            }            
            else if ((!this.compras[1] && !this.compras[2] && typeof this.compras[3] === 'object')){
                $('#nav-tab li:nth-child(3) a').tab('show');
            }
            else if ((!this.compras[1] && !this.compras[2] && !this.compras[3] && typeof this.compras[4] === 'object') || this.view_recive == 1){
                $('#nav-tab li:nth-child(4) a').tab('show');
            }
        }      
    },
    methods: {
        initializeDataTables(){
            if ( ! $.fn.DataTable.isDataTable(this.$refs.tabla_contenedora_ep ) ) {
                $(this.$refs.tabla_contenedora_ep).DataTable({
                    "language": {
                            url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json"
                        },
                        dom: 'lftip',
                        pageLength: 10,
                        order: [
                            [1, 'desc'],
                        ],
                        columnDefs: [{
                                targets: [6],
                                orderable: false
                            } // Columnas 0 (ID) y 2 (Correo) no son ordenables
                        ]
                });
            }
            
            if ( ! $.fn.DataTable.isDataTable(this.$refs.tabla_contenedora_en ) ) {
                $(this.$refs.tabla_contenedora_en).DataTable({
                    "language": {
                            url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json"
                        },
                        dom: 'lftip',
                        pageLength: 10,
                        order: [
                            [1, 'desc'],
                        ],
                        columnDefs: [{
                                targets: [7],
                                orderable: false
                            } // Columnas 0 (ID) y 2 (Correo) no son ordenables
                        ]
                });
            }
            
            if ( ! $.fn.DataTable.isDataTable(this.$refs.tabla_contenedora_re ) ) {
                $(this.$refs.tabla_contenedora_re).DataTable({
                    "language": {
                            url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json"
                        },
                        dom: 'lftip',
                        pageLength: 10,
                        order: [
                            [1, 'desc'],
                        ], 
                        columnDefs: [{
                                targets: [9],
                                orderable: false
                            } // Columnas 0 (ID) y 2 (Correo) no son ordenables
                        ]                   
                });
            }
            
            if ( ! $.fn.DataTable.isDataTable(this.$refs.tabla_contenedora_nr ) ) {
                $(this.$refs.tabla_contenedora_nr).DataTable({
                    "language": {
                            url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json"
                        },
                        dom: 'lftip',
                        pageLength: 10,
                        order: [
                            [1, 'desc'],
                        ],
                        columnDefs: [{
                                targets: [6],
                                orderable: false
                            } // Columnas 0 (ID) y 2 (Correo) no son ordenables
                        ]
                });
            }
                
            this.dataLoaded = false;
        },
        getReason(){
            axios.get('/api/reason/'+this.tipo_evaluacion).then((response) => {
                this.reasons = response.data;
            });
        },
        loadPost() {
            const url = window.location.href;
            //cuando viene de la vista (Mis ventas)
            if (url.includes('ventas')){
                axios.get('/api/sale/'+this.post_id+'/'+this.estado_id).then((response) => {
                    this.compras = response.data;
                    this.dataLoaded = true; 
                });
            }
            //Cuando viene de la vista (Mis compras)
            else{
                axios.get('/api/compras').then((response) => {
                    this.compras = response.data;
                    this.dataLoaded = true; 
                }); 
            }
        },
        saveConfirm(){
            this.view_recive = 1;
            axios.post('/api/sale/confirm',{ //estas variables son las que enviaremos para que crear la tarea
                'id_user' : this.seller_id,
                'id_sale': this.sale_id,
                'rating': this.rating,
                'comment_buyer': this.comment_buyer,
                'reason': this.selected_reason,
                'evaluacion': this.selected_evaluacion
            }).then((response) => {
                //console.log(response);
                if (response.data.msj == 'sale_confirm'){
                    this.loadPost();  
                //this.id_rating = response.data.data;
                //console.log(this.id_puja);
                this.$swal.fire({
                    text: 'gracias por calificar.',
                    title: 'Hemos registrado la calificación de la compra de tu producto',
                    icon: 'success',
                    confirmButtonColor: '#3490dc',
                    confirmButtonText: 'Aceptar'
                });
            
                }
            })
            .catch((response) => {
                this.$swal.fire({
                    text: 'Por favor, trata de calificar nuevamente',
                    title: 'No se ha podido registrar la calificación de la compra del producto',
                    icon: 'error',
                    confirmButtonColor: '#3490dc',
                    confirmButtonText: 'Aceptar'
                });
            });
        },
        saveConfirmBuy(){
            this.view_recive = 1;
            axios.post('/api/sale/confirmbuy',{ //estas variables son las que enviaremos para que crear la tarea
                'id_user' : this.comprador.id_buyer,
                'id_sale': this.comprador.id,
                'rating': this.rating,
                'comment_buyer': this.comment_buyer,
                'send_price': this.sendPrice,
                'reason': this.selected_reason,
                'evaluacion': this.selected_evaluacion
            }).then((response) => {
                //console.log(response);
                if (response.data.msj == 'sale_confirm'){
                    this.loadPost();  
                this.$swal.fire({
                    text: 'gracias por calificar.',
                    title: 'Hemos registrado la calificación de venta del producto',
                    icon: 'success',
                    confirmButtonColor: '#3490dc',
                    confirmButtonText: 'Aceptar'
                });
                setTimeout(() => {
                    if (response.data.msj == 'sale_confirm'){
                        this.$router.push({ path: '/puja/'+this.id_puja } );
                        this.$router.push('/sale/post');
                        this.$router.go();
                    }  
                    }, 2000);      
                }
            })
            .catch((response) => {
                this.$swal.fire({
                    text: 'Por favor, trata de calificar nuevamente',
                    title: 'No se ha podido registrar la calificación de venta del producto',
                    icon: 'error',
                    confirmButtonColor: '#3490dc',
                    confirmButtonText: 'Aceptar'
                });
            });
        },
        viewSeller(user_name, user_phone, user_email, user_city){
            this.seller_name = user_name; 
            this.seller_phone = user_phone;
            this.seller_email = user_email;
            this.seller_city = user_city;
        },
        viewConfirm(id_seller, id_sale, fecha_envio){
            this.seller_id = id_seller;
            this.sale_id = id_sale;
            this.view_recive = 1;
            this.selected_evaluacion = 0;
            this.selected_reason = 0;
            this.comment_buyer = '';
            this.class_estrellitas = 'd-none';
            this.fecha_envio = fecha_envio;
            document.querySelector('#rating0').checked = true; 
        },
        viewConfirmSend(compra){
            this.comprador = compra;
            this.salePrice = compra.price.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    });
            this.saleCantidad = compra.cantidad_puja;                        
            this.view_send = 1;
        },
        viewBuyerInfo(compra){
            this.comprador = compra;
            this.salePrice = compra.price.toLocaleString("es-CL", {
                                    style: "currency",
                                    currency: "CLP",
                                    });
            this.saleCantidad = compra.cantidad_puja;                         
            this.view_send = 1;
        },
        getRating() {
            let estrellas = document.querySelector('input[name=rating]:checked').value;
            document.getElementById("texto").innerHTML = (
                0 < estrellas ?
                estrellas + " estrella" + (1 < estrellas ? "s" : "") :
                "sin calificar"
            );
            this.rating = estrellas;
        },
        enmascararValor() {
            var costoenvio = this.$refs.costoEnvio;
            var v_costoenvio = limpia_precio(costoenvio.value);

            obtener_precio(costoenvio);

            if (parseInt(v_costoenvio) < 0) {
                this.$swal.fire({
                    text: 'Por favor, ingresar nuevamente',
                    title: 'El costo de envío debe ser mayor o igual a 0',
                    icon: 'error',
                    confirmButtonColor: '#3490dc',
                    confirmButtonText: 'Aceptar'
                });
                costoenvio.value = '';
            }
            obtener_precio(costoenvio);

            validar(document.formulario);
        }, 
        setReason(){
            //valor por omisión cuando se evalúa positivo, el combo de razón queda con este valor, para que se active la validación
            this.selected_reason = 'POSITIVA';
            this.class_estrellitas = '';
            this.getRating();
            this.class_reason = 'form-group row d-none';
            if (this.selected_evaluacion == 2){
                this.selected_reason = '';
                this.tipo_evaluacion = 2;
                if (this.estado_id > 0){
                    this.tipo_evaluacion = 1;
                }    
                this.getReason();
                this.class_estrellitas = 'd-none';
                this.class_reason = 'form-group row';
                this.rating = 0;
                document.querySelector('#rating0').checked = true;                
            }
            else if (this.selected_evaluacion == '' || !this.selected_evaluacion){
                this.class_estrellitas = 'd-none';
            }      
        },
        sumarDias(fechaActual,dias) {
            const fecha_actual = new Date(); // Fecha actual
            let dia_actual = String(fecha_actual.getDate()).padStart(2, '0');
            let mes_actual = String(fecha_actual.getMonth() + 1).padStart(2, '0'); // Los meses comienzan desde 0
            let anio_actual = fecha_actual.getFullYear()

            
            let fechaConversion = fechaActual.substr(0,10).split('-');
            let fechaActualizada = new Date(fechaConversion[2]+'-'+fechaConversion[1]+'-'+fechaConversion[0]);
            
            const anio = fechaActualizada.getFullYear();
            const mes = String(fechaActualizada.getMonth() + 1).padStart(2, '0');
            const dia = String(fechaActualizada.getDate() + dias + 1).padStart(2, '0');

            fechaActualizada = anio+mes+dia;
            let fecha_hoy = anio_actual+''+mes_actual+''+dia_actual;

            if (parseInt(fechaActualizada) < parseInt(anio_actual+mes_actual+dia_actual) ){
                 return true;
            }
            return false;
        },
        getFilter(data){
            if(data == ''){
                data='Titulo: ';
            }
            let data_url = 'find';
            fetch("/api/post_filter/"+ data_url +"/?page=" + this.currentPage +"&filtro=" + data +'&orden=' + this.orden)
                    .then((response) => response.json())
                    .then((json) => {
                    this.posts = json.data.data;
                    this.total = json.data.last_page;
                    });
        },
        viewCalification(sale_id){
            if(sale_id){
                if (this.url != 'post.index'){
                    this.view_recive = 1;
                    this.type_view = 2;
                }else{
                    this.view_send = 1;
                    this.type_view = 1;
                }
                fetch("/api/rating/"+ sale_id + "/" + this.type_view)
                    .then((response) => response.json())
                    .then((json) => {
                    this.ratings = json;
                    
                    });
            }
        },
        range(n) {
            return Array.from({ length: n }, (v, k) => k + 1);
        },
    }    
};
</script>
<style>
label {
  display: inline-block;
  padding: 0;
  cursor: pointer;
  vertical-align: middle;
}

label.reset {
  font-size: 10px;
  border: 1px solid #000;
  border-radius: 5px;
  margin: 10px 5px;
  padding: 2px 3px;
}

label.star {
  width: 30px;
  height: 27px;
}


/* ocultamos los radiobuttons */

input[name=rating] {
  display: none;
}


/* estrellas inmediatamente despues de un radiobutton van amarillas */

input[type=radio]+label.star svg path {
  fill: #fe0
}


/* estrellas a la derecha del radiobutton checked van blanco */

input[type=radio]:checked~label.star svg path {
  fill: #fff;
}
</style>